import _typeof from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.json.stringify.js";
// const moment = require("moment");
var requests = require("../utils/requests").default;
var moment = require("moment");
import alertMixin from "./alert.js";
import settingMixin from "./settings.js";
export default {
  mixins: [alertMixin, settingMixin],
  data: function data() {
    var _sample_basic_task_ob;
    return {
      saving: false,
      loadingFiles: false,
      all_time_entries: [],
      attachments: [],
      all_time_entries_key: "all_time_entries_key",
      show_add_new: {},
      sample_basic_task_object: (_sample_basic_task_ob = {
        subject: "",
        record_id: null,
        expected_duration: '',
        hold_reason: '',
        allPlans: {},
        description: '',
        task_results: '',
        project: {
          value: null,
          name: ''
        },
        priority: {
          value: 3,
          name: 'Medium'
        },
        task_type: {
          value: 1
        },
        // start_date: moment().format("YYYY-MM-DD"),
        // start_date_dmy: moment().format("YYYY-MM-DD"),
        // end_date: moment().format("YYYY-MM-DD"),
        // end_date_dmy: moment().format("YYYY-MM-DD"),
        dateRange: ['', ''],
        start_date: '',
        start_date_dmy: '',
        end_date: '',
        end_date_dmy: '',
        record_owner: {},
        task_status: {
          value: 6
        },
        section: {
          value: null
        },
        status: {
          value: 6
        },
        account: {
          value: ''
        }
      }, _defineProperty(_sample_basic_task_ob, "section", {
        value: ''
      }), _defineProperty(_sample_basic_task_ob, "users", []), _defineProperty(_sample_basic_task_ob, "account_name", this.selected_project && this.selected_project.account_name ? this.selected_project.account_name : {
        value: ''
      }), _sample_basic_task_ob)
    };
  },
  computed: {
    lastTaskUpdate: {
      get: function get() {
        return this.$store.state.tasks.lastTaskUpdate;
      },
      set: function set(val) {
        this.$store.state.tasks.lastTaskUpdate = val;
      }
    },
    timeCounter: {
      get: function get(val) {
        return this.$store.state.tasks.timeCounter;
      },
      set: function set(val) {
        this.$store.state.tasks.timeCounter = val;
      }
    },
    timeCounterAll: {
      get: function get(val) {
        return this.$store.state.tasks.timeCounterAll;
      },
      set: function set(val) {
        this.$store.state.tasks.timeCounterAll = val;
      }
    }
  },
  methods: {
    add_new_subtask: function add_new_subtask(i, save) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var allsubtasks, changed, method, order, blank;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              allsubtasks = null;
              if (!_this.any_change) {
                _context.next = 9;
                break;
              }
              if (!(save && _this.subtasks && _this.taskId)) {
                _context.next = 9;
                break;
              }
              // allsubtasks  = await this.save_subtask(this.subtasks);
              changed = _objectSpread({}, _this.subtasks[i]);
              if (changed && changed.record_owner && changed.record_owner.value) {
                changed.record_owner = changed.record_owner.value;
              }
              if (changed && changed.main_task && changed.main_task.value) {
                changed.main_task = changed.main_task.value;
              }
              method = changed.record_id ? "update" : "create";
              _context.next = 9;
              return new KivaProxy({
                endpoint: "act/subtask"
              })[method](changed).then(function (data) {
                _this.subtasks[i].record_id = data.records[0].record_id;
              });
            case 9:
              if (!_this.subtasks) {
                // if (!this.subtasks && !this.subtasks[i + 1]) {
                order = _this.subtasks ? _this.subtasks.length : 0;
                blank = {
                  record_id: 0,
                  sort_order: order,
                  main_task: {
                    value: _this.taskId
                  },
                  dependency: {
                    value: 0,
                    name: ""
                  },
                  record_owner: _this.new_task.record_owner,
                  subject: ""
                };
                _this.subtasks.push(blank);
                if (_this.isSelectNewTask) {
                  _this.SelectNewTask(250);
                }
                _this.any_change = false;
                _this.created = true;
              }
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    findStatusColor: function findStatusColor(status, type) {
      var sts = this.$store.state.task_status;
      var color = sts.find(function (k) {
        return k.id == status;
      }).color;
      if (type == 'bg') {
        return '#' + color + '26';
      } else {
        return '#' + color;
      }
    },
    reOpenTask: function reOpenTask(data, id) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result, ft;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              data.task_status.value = 1;
              // console.log(data)
              _context2.next = 3;
              return _this2.save_task(data, "standart");
            case 3:
              result = _context2.sent;
              ft = _this2.tasks.filter(function (k) {
                return k.record_id == id;
              });
              if (ft[0]) {
                ft[0].task_status.value = 1;
                ft[0].task_status.name = "Open";
                _this2.$emit("filtered_tasks_finder", true);
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    set_basic_task_data: function set_basic_task_data() {
      var me = _objectSpread({}, this.$store.state.users.CURRENT_USER);
      this.sample_basic_task_object.record_owner = me && me.userId ? {
        value: me.userId,
        label: me.firstname + " " + me.lastname
      } : {};
      if (me && me.userId) {
        this.sample_basic_task_object.users = [me.userId];
      }
      if (this.$store.state.project.project && this.$store.state.project.project.record_id) {
        this.sample_basic_task_object.project = {
          value: this.$store.state.project.project.record_id,
          label: this.$store.state.project.project.project_name
        };
      }
      this.basic_task = _objectSpread({}, this.sample_basic_task_object);
    },
    get_duration_color: function get_duration_color(time) {
      if (time < -8) {
        return "green";
      }
      if (time < 0) {
        return "yellow";
      }
      if (time < 8) {
        return "orange";
      }
      if (time >= 8) {
        return "red";
      }
    },
    moment_overdue_duration: function moment_overdue_duration(date) {
      if (date) {
        var day = Math.floor(date / 24);
        var saat = Math.abs(date - day * 24);
        return "".concat(day ? day + 'g' : saat + 's');
      } else {
        return "0dk";
      }
    },
    hour_moment_list: function hour_moment_list(hour) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "text";
      if (hour) {
        var saat = Math.floor(hour / 60 / 60);
        var dakika = Math.abs(hour / 60 - saat * 60);
        if (style == "text") {
          return "".concat(saat ? saat + 'h' : '').concat(dakika ? dakika + 'm' : '');
        } else {
          saat = saat && saat < 10 ? "0".concat(saat) : saat;
          dakika = dakika && dakika < 10 ? "0".concat(dakika) : dakika;
          return "".concat(saat ? saat : '00', ":").concat(dakika ? dakika + '' : '00');
        }
      } else {
        if (style == "text") {
          return "-";
        } else {
          return '00:00';
        }
      }
    },
    hour_moment: function hour_moment(hour) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "text";
      if (hour) {
        var saat = Math.floor(hour / 60);
        var dakika = Math.abs(hour - saat * 60);
        if (style == "text") {
          return "".concat(saat ? saat + 'h' : '').concat(dakika ? dakika + 'm' : '');
        } else {
          saat = saat && saat < 10 ? "0".concat(saat) : saat;
          dakika = dakika && dakika < 10 ? "0".concat(dakika) : dakika;
          return "".concat(saat ? saat : '00', ":").concat(dakika ? dakika + '' : '00');
        }
      } else {
        if (style == "text") {
          return "-";
        } else {
          return '00:00';
        }
      }
    },
    list_subtasks: function list_subtasks() {
      var _arguments = arguments,
        _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var is_add_new, subtasks, i, size;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              is_add_new = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : true;
              if (!(_this3.new_task && _this3.new_task.record_id && _this3.new_task.sub_tasks != "0/0")) {
                _context3.next = 9;
                break;
              }
              _context3.next = 4;
              return requests.get_subtasks({
                main_task: _this3.new_task.record_id
              });
            case 4:
              subtasks = _context3.sent;
              _this3.subtasks = subtasks.records;
              if (is_add_new && _this3.add_new_subtask) {
                i = _this3.subtasks.length + 1;
                _this3.add_new_subtask(i, false);
              }
              _context3.next = 11;
              break;
            case 9:
              // yeni formda açılacak
              size = _this3.subtasks && _this3.subtasks.length ? _this3.subtasks.length : 0; // console.log(" this.new_task.sub_tasks", this.new_task.sub_tasks)
              if (size == 0 && (_this3.add_new_subtask || _this3.new_task.sub_tasks == "0/0")) {
                _this3.add_new_subtask(size, false);
              }
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    save_task_as_complete: function save_task_as_complete(data, status) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var result;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              data.task_status = status;
              _context4.next = 3;
              return _this4.save_task(data);
            case 3:
              result = _context4.sent;
              if (result) {
                _this4.add_to_complete(data.record_id);
              }
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    add_to_complete: function add_to_complete(id) {
      var ft = this.tasks.filter(function (k) {
        return k.record_id == id;
      });
      if (ft[0]) {
        ft[0].task_status.value = "3";
        ft[0].task_status.name = "Completed";
        this.$emit("filtered_tasks_finder", true);
      }
    },
    show_date: function show_date(date) {
      return moment(date).format("DD MMM YY hh:ss");
    },
    show_only_date: function show_only_date(date) {
      return moment(date).format(this.$store.state.settings.dateFormat);
    },
    list_notes: function list_notes() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var notes;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return requests.get_notes(_this5.taskData.record_id);
            case 2:
              notes = _context5.sent;
              if (notes && notes.records) {
                notes.records.forEach(function (e, i) {
                  notes.records[i].editable = false;
                });
              }
              _this5.notes = notes.records;
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    checkTimeEntry: function checkTimeEntry(all_time_entries, project_type) {
      if (project_type == '0') {
        return true;
      }
      if (all_time_entries && all_time_entries[0] || this.getSetting('task', 'timeEntryRequired') === false) {
        return true;
      }
      return false;
    },
    save_task: function save_task(data, from) {
      var _arguments2 = arguments,
        _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var isRefresh, originalTask, id, search;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              isRefresh = _arguments2.length > 2 && _arguments2[2] !== undefined ? _arguments2[2] : false;
              originalTask = _arguments2.length > 3 && _arguments2[3] !== undefined ? _arguments2[3] : {};
              if (!(data.task_status && (data.task_status == 3 || data.task_status.value == 3))) {
                _context6.next = 12;
                break;
              }
              id = data.record_id;
              search = {
                done: ["=", 0]
              };
              search.main_task = ["=", id];
              _context6.next = 8;
              return new KivaProxy({
                endpoint: 'act/subtask'
              }).setFilters(search).setFields(["sort_order", "done", "main_task", "subject", "record_owner", "created_on", "created_by"]).setSort("sort_order").setDir('ASC').setLimit(1000).all().then(function (response) {
                if (response.records && response.records[0]) {
                  _this6.$store.state.tasks.popup.task = {
                    record_id: id
                  };
                  _this6.$store.state.tasks.popup.show = true;
                  _this6.$confirm("You have " + response.total + " open subtask(s) in this Task. Please check the subtasks before.", "Warning", {
                    confirmButtonText: "OK",
                    showCancelButton: false,
                    // cancelButtonText: "Cancel",
                    type: "warning"
                  }).then(function (response) {
                    _this6.$store.state.tasks.popup.task = {
                      record_id: id
                    };
                    _this6.$store.state.tasks.popup.show = true;
                  });
                } else {
                  _this6.save_task_continue(data, from, isRefresh, originalTask);
                }
              }).catch(function (err) {
                return {
                  status: "Fail",
                  records: []
                };
              });
            case 8:
              _context6.next = 10;
              return _context6.sent;
            case 10:
              _context6.next = 13;
              break;
            case 12:
              _this6.save_task_continue(data, from, isRefresh, originalTask);
            case 13:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    save_task_continue: function save_task_continue(data, from) {
      var _arguments3 = arguments,
        _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var isRefresh, originalTask, _require, ActTaskTransformer, rtn, record_id, isCreate, new_task, keys, _new_task, text;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              isRefresh = _arguments3.length > 2 && _arguments3[2] !== undefined ? _arguments3[2] : false;
              originalTask = _arguments3.length > 3 && _arguments3[3] !== undefined ? _arguments3[3] : {};
              console.log("data.attachmentsList", data.attachmentsList);
              // return;
              if (!data.subject) {
                _context7.next = 51;
                break;
              }
              _this7.$store.commit("savingStart", {
                status: 1
              });
              _this7.saving = true;
              _require = require('@/transformers/ActTaskTransformer'), ActTaskTransformer = _require.ActTaskTransformer; // console.log("data.attachmentsList 1 - ",data.attachmentsList);
              if (!(data && data.subject)) {
                _context7.next = 51;
                break;
              }
              if (data.start_date == 'Invalid date') {
                data.start_date == data.end_date;
              }
              _context7.next = 11;
              return requests.upsert_task(_objectSpread(_objectSpread({}, data), {}, {
                from: from
              }));
            case 11:
              rtn = _context7.sent;
              record_id = rtn.records[0].record_id;
              isCreate = true; // console.log("data",data);
              // console.log("this.new_task",this.new_task);
              if (!(_this7.new_task && data.record_id == "new" || data.record_id == '' || data.record_id == null)) {
                _context7.next = 36;
                break;
              }
              isCreate = true;
              new_task = null; // console.log("data.attachmentsList 2 - ",data.attachmentsList); 
              _context7.next = 19;
              return new KivaProxy({
                endpoint: 'act/task'
              }).find(record_id).then(function (response) {
                new_task = ActTaskTransformer.fetch(response.record);
                if (originalTask && _typeof(originalTask) == "object") {
                  Object.assign(originalTask, new_task);
                  Object.assign(data, new_task);
                }
              });
            case 19:
              if (!(data.attachmentsList && data.attachmentsList[0])) {
                _context7.next = 22;
                break;
              }
              _context7.next = 22;
              return _this7.upload_task_attachment("all", data.attachmentsList, record_id, 'act', 'task');
            case 22:
              if (data.allPlans && data.allPlans) {
                keys = Object.keys(data.allPlans);
                keys.forEach(function (k) {
                  var plan = data.allPlans[k];
                  var setData = {
                    duration: plan.duration * 60,
                    task: record_id,
                    start_date: plan.date,
                    end_date: plan.date,
                    record_owner: data.record_owner.value,
                    activity_type: 1,
                    allday: 1
                  };
                  new KivaProxy({
                    endpoint: 'act/plan'
                  }).create(setData, {
                    upsert: true
                  }).then(function (data) {}).catch(function (err) {
                    console.log(err);
                  });
                });
              }

              // if(isRefresh){
              _this7.$store.state.tasks.lastTaskUpdate = {
                id: record_id,
                work: "create",
                time: moment(),
                task: new_task
              };
              // }
              _this7.new_task = new_task;
              if (!(_this7.subTasks && _this7.subTasks[0] && _this7.subTasks[0].subject && _this7.subTasks[0].subject != "")) {
                _context7.next = 29;
                break;
              }
              _this7.subTasks.forEach(function (e) {
                e.main_task.value = record_id;
              });
              // this.starter(); 
              _context7.next = 29;
              return _this7.save_subtask(_this7.subTasks);
            case 29:
              _this7.set_basic_task_data();
              _this7.$store.state.tasks.tasks.push(_this7.new_task);
              _this7.$store.state.tasks.tasks.sort(function (a, b) {
                if (b.end_date) {
                  return new Date(b.end_date) - new Date(a.end_date);
                }
              });
              _this7.$emit("setEvent", {
                command: "filter"
              });
              // this.filtered_tasks[status.id].unshift(this.new_task);
              _this7.$emit("filtered_tasks_finder", true);
              _context7.next = 45;
              break;
            case 36:
              isCreate = false;
              if (!(originalTask && _typeof(originalTask) == "object")) {
                _context7.next = 43;
                break;
              }
              _context7.next = 40;
              return requests.get_task(record_id);
            case 40:
              _new_task = _context7.sent;
              if (!_new_task.section || _new_task.section == null) {
                _new_task.section = {
                  value: null,
                  label: ""
                };
              }
              Object.assign(originalTask, _new_task);
            case 43:
              // if(isRefresh){
              _this7.$store.state.tasks.lastTaskUpdate = {
                id: record_id,
                work: "create",
                time: moment(),
                task: data
              };
              // }
              setTimeout(function () {
                _this7.list_subtasks();
              }, 1500);
            case 45:
              if (typeof _this7.any_change != "undefined") {
                _this7.any_change = true;
              }
              text = "";
              if (rtn.status == "Success") {
                _this7.$store.commit("savingEnd", {
                  status: 2,
                  result: {
                    app: 'act',
                    modul: 'task',
                    recordId: record_id,
                    time: moment().format("DD-MM-YYYY HH:mm:ss")
                  }
                });
                if (rtn.text) {
                  text = rtn.text;
                } else {
                  text = _this7.$t('The task successfully saved.');
                }
                if (typeof _this7.clean_add_form !== "undefined") {
                  _this7.clean_add_form();
                }
                _this7.$store.state.response_alert = {
                  name: "Kullanıcı",
                  title: _this7.$t("Congratulations"),
                  text: text,
                  status: true,
                  modal: true,
                  class: "success"
                };
                _this7.set_basic_task_data();
                setTimeout(function () {
                  _this7.saving = false;
                }, 700);
              } else {
                _this7.$store.commit("savingEnd", {
                  status: 3,
                  result: {
                    app: 'act',
                    modul: 'task',
                    recordId: record_id,
                    time: moment().format("DD-MM-YYYY HH:mm:ss")
                  }
                });
                if (rtn.text) {
                  text = rtn.text;
                  if (rtn.err) {
                    text = text + rtn.err;
                  }
                } else {
                  text = _this7.$t("An error occurred while recording.");
                }
                _this7.$store.state.response_alert = {
                  name: "Kullanıcı",
                  title: _this7.$t("Christ no!"),
                  text: text,
                  status: true,
                  modal: true,
                  class: "warning"
                };
                setTimeout(function () {
                  _this7.saving = false;
                }, 700);
                // this.start_notify()
              }

              setTimeout(function () {
                _this7.$store.state.response_alert.status = false;
              }, 2000);
              if (from == "inside") {
                // this.key_for_refresh_component_new();
              } else if (from == "drawer") {}
              return _context7.abrupt("return", true);
            case 51:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    toogleStatus: function toogleStatus() {
      this.status.show = !this.status.show;
    },
    key_for_refresh_component_new: function key_for_refresh_component_new() {
      this.key_for_refresh_component = "r" + Math.random() * 10000 + 1;
    },
    save_subtask: function save_subtask(data, from) {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this8.subTasksLoading = true;
              _context8.next = 3;
              return requests.save_subtasks(_objectSpread({}, data)).then(function (rtn) {
                var text = "";
                if (rtn && rtn.status == "Success") {
                  _this8.subTasksLoading = false;
                  // setTimeout(async () => {  await this.list_subtasks(true);  }, 1000);
                  if (rtn && rtn.text) {
                    text = rtn.text;
                  } else {
                    text = _this8.$t("Subtasks successfully saved.");
                  }
                  _this8.$store.state.response_alert = {
                    text: text,
                    class: "success"
                  };
                } else {
                  _this8.subTasksLoading = false;
                  if (rtn && rtn.text) {
                    text = rtn.text;
                    if (rtn.err) {
                      text = text + rtn.err;
                    }
                  } else {
                    text = _this8.$t("Error while saving.");
                  }
                  _this8.$store.state.response_alert = {
                    text: text,
                    class: "warning"
                  };
                }
                // this.start_notify() 
              });
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    save_task_note: function save_task_note(data, record_id) {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var rtn, text;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              // console.log(data)
              _this9.saving = true;
              _context9.next = 3;
              return requests.save_note(_objectSpread(_objectSpread({}, data), {}, {
                record_id: record_id
              }));
            case 3:
              rtn = _context9.sent;
              _this9.saving = false;
              _this9.list_notes();
              text = "";
              if (rtn.status == "Success") {
                _this9.new_note.message = '';
                if (rtn.text) {
                  text = rtn.text;
                } else {
                  text = _this9.$t("Notes saved successfully.");
                }
                _this9.$store.state.response_alert = {
                  name: "Kullanıcı",
                  title: _this9.$t("Congratulations"),
                  text: text,
                  status: true,
                  modal: true,
                  class: "success"
                };
              } else {
                if (rtn.text) {
                  text = rtn.text;
                  if (rtn.err) {
                    text = text + rtn.err;
                  }
                } else {
                  text = _this9.$t("An error occurred while saving the note.");
                }
                _this9.$store.state.response_alert = {
                  name: "Kullanıcı",
                  title: _this9.$t("Christ no!"),
                  text: text,
                  status: true,
                  modal: true,
                  class: "warning"
                };
              }
              _this9.start_notify();
            case 9:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    list_dependencies: function list_dependencies() {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var dependencies;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return requests.list_task_dependency({
                record_id: _this10.task_id
              });
            case 2:
              dependencies = _context10.sent;
              if (dependencies.records) {
                dependencies.records.forEach(function (k) {
                  if (k.dependency_type == null) {
                    k.dependency_type = {
                      value: "0",
                      label: "null"
                    };
                  }
                });
              }
              _this10.all_dependencies = dependencies.records;
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    isEstimatedRequired: function isEstimatedRequired(selected_project, project) {
      var find = this.projects.find(function (k) {
        return k.record_id == project.record_id;
      });
      return selected_project && selected_project.time_estimation_required || find && find.time_estimation_required ? true : false;
    },
    save_dependency: function save_dependency(data) {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var me, rtn, text;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              me = _objectSpread({}, _this11.$store.state.users.CURRENT_USER);
              data[0].task = {
                value: _this11.task_id
              };
              _this11.saving = true;
              _context11.next = 5;
              return requests.save_dependency(_objectSpread(_objectSpread({}, data), {}, {
                me: me
              }));
            case 5:
              rtn = _context11.sent;
              _context11.next = 8;
              return _this11.list_dependencies();
            case 8:
              _this11.$emit("updateShow", false);
              text = "";
              if (rtn.status == "Success") {
                if (rtn.text) {
                  text = rtn.text;
                } else {
                  text = _this11.$t("The task  successfully saved.");
                }
                _this11.$store.state.response_alert = {
                  name: "Kullanıcı",
                  title: _this11.$t("Congratulations"),
                  text: text,
                  status: true,
                  modal: true,
                  class: "success"
                };
              } else {
                if (rtn.text) {
                  text = rtn.text;
                  if (rtn.err) {
                    text = text + rtn.err;
                  }
                } else {
                  text = _this11.$t("Kayıt yapılırken hata oluştu.");
                }
                _this11.$store.state.response_alert = {
                  name: "Kullanıcı",
                  title: _this11.$t("Christ no!"),
                  text: text,
                  status: true,
                  modal: true,
                  class: "warning"
                };
              }
              _this11.saving = false;
              _this11.start_notify();
              // setTimeout(() => {
              //     let default_response_alert = this.$store.state.default_response_alert
              //     let response_alert = this.$store.state.response_alert

              //     this.$store.state.response_alert = this.$store.state.default_response_alert
              // }, 2000);
            case 13:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    delete_subtask: function delete_subtask(data) {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var rtn, text;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this12.saving = true;
              _context12.next = 3;
              return requests.delete_subtask(data);
            case 3:
              rtn = _context12.sent;
              text = "";
              if (rtn.status == "Success") {
                if (rtn.text) {
                  text = rtn.text;
                } else {
                  text = _this12.$t("Subtasks successfully saved.");
                }
                _this12.$store.state.response_alert = {
                  name: "Kullanıcı",
                  title: _this12.$t("Congratulations"),
                  text: text,
                  status: true,
                  modal: true,
                  class: "success"
                };
                // await this.list_subtasks(false);
              } else {
                if (rtn.text) {
                  text = rtn.text;
                  if (rtn.err) {
                    text = text + rtn.err;
                  }
                } else {
                  text = _this12.$t("Error while saving.");
                }
                _this12.$store.state.response_alert = {
                  name: "Kullanıcı",
                  title: _this12.$t("Christ no!"),
                  text: text,
                  status: true,
                  modal: true,
                  class: "warning"
                };
              }
              _context12.next = 8;
              return _this12.list_subtasks(true);
            case 8:
              _this12.saving = false;
              _this12.start_notify();
            case 10:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    delete_task: function delete_task(data, isRefresh) {
      var _this13 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var rtn, text;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this13.saving = true;
              _context13.next = 3;
              return requests.delete_task(data, isRefresh);
            case 3:
              rtn = _context13.sent;
              text = "";
              if (rtn.status == "Success") {
                if (rtn.text) {
                  text = rtn.text;
                } else {
                  text = _this13.$t("Task successfully deleted.");
                }
                // if(isRefresh){
                _this13.$store.state.tasks.lastTaskUpdate = {
                  id: data.record_id,
                  work: "delete",
                  time: moment(),
                  task: data
                };
                // } 

                _this13.$store.state.response_alert = {
                  name: "Kullanıcı",
                  title: _this13.$t("Congratulations"),
                  text: text,
                  status: true,
                  modal: true,
                  class: "success"
                };
              } else {
                if (rtn.text) {
                  text = rtn.text;
                  if (rtn.err) {
                    text = text + rtn.err;
                  }
                } else {
                  text = _this13.$t("Error while saving.");
                }
                _this13.$store.state.response_alert = {
                  name: "Kullanıcı",
                  title: _this13.$t("Christ no!"),
                  text: text,
                  status: true,
                  modal: true,
                  class: "warning"
                };
              }
              _this13.saving = false;
              _this13.start_notify();
            case 8:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    delete_dependency: function delete_dependency(data) {
      var _this14 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var rtn, text;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this14.saving = true;
              _context14.next = 3;
              return requests.delete_dependency(data);
            case 3:
              rtn = _context14.sent;
              text = "";
              if (rtn.status == "Success") {
                if (rtn.text) {
                  text = rtn.text;
                } else {
                  text = _this14.$t("Dependency deleted successfully.");
                }
                _this14.$store.state.response_alert = {
                  name: "Kullanıcı",
                  title: _this14.$t("Congratulations"),
                  text: text,
                  status: true,
                  modal: true,
                  class: "success"
                };

                //paneli kapatma

                // await this.list_subtasks(false);
              } else {
                if (rtn.text) {
                  text = rtn.text;
                  if (rtn.err) {
                    text = text + rtn.err;
                  }
                } else {
                  text = _this14.$t("Error while saving.");
                }
                _this14.$store.state.response_alert = {
                  name: "Kullanıcı",
                  title: _this14.$t("Christ no!"),
                  text: text,
                  status: true,
                  modal: true,
                  class: "warning"
                };
              }
              _context14.next = 8;
              return _this14.list_dependencies();
            case 8:
              _this14.$emit("updateShow", false);
              _this14.saving = false;
              _this14.start_notify();
              // setTimeout(() => {

              //     let default_response_alert = this.$store.state.default_response_alert
              //     let response_alert = this.$store.state.response_alert

              //     this.$store.state.response_alert = this.$store.state.default_response_alert
              // }, 2000); 
            case 11:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    ////////// --------- TIME ENTRY
    format_date: function format_date(date) {
      return moment(date).format("DD/MM/YY");
    },
    format_time: function format_time(date) {
      return moment(date).format("HH:mm");
    },
    save_time_entry: function save_time_entry(data) {
      var _arguments4 = arguments,
        _this15 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var task, type, rtn, text, tea, te;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              task = _arguments4.length > 1 && _arguments4[1] !== undefined ? _arguments4[1] : {};
              _this15.saving = true;
              type = task && task.object_type ? task.object_type : "TASK";
              _context15.next = 5;
              return requests.save_time_entry({
                data: _objectSpread({}, data),
                task: _objectSpread({}, task)
              });
            case 5:
              rtn = _context15.sent;
              if (!(task && task.record_id)) {
                _context15.next = 9;
                break;
              }
              _context15.next = 9;
              return _this15.list_time_entries(task.record_id, null, null, type);
            case 9:
              text = "";
              if (rtn && rtn.status == "Success") {
                if (rtn.text) {
                  text = rtn.text;
                } else {
                  text = _this15.$t("Time entry  successfully saved.");
                }
                _this15.$store.state.response_alert = {
                  name: "Kullanıcı",
                  title: _this15.$t("Congratulations"),
                  text: text,
                  status: true,
                  modal: true,
                  class: "success"
                };

                // remove time entry from list 
                if (data && data.id) {
                  tea = window.localStorage.getItem("timeCounterAll");
                  te = [];
                  if (tea && tea.charAt(0) == "[") {
                    te = JSON.parse(tea);
                    te = te.filter(function (k) {
                      return k && k.id != data.id;
                    });
                    window.localStorage.setItem("timeCounterAll", JSON.stringify(te));
                    _this15.timeCounterAll = te;
                  }
                }
                _this15.$emit("all_time_entries", _this15.all_time_entries);
                _this15.$emit("all_time_entries_key", Math.random(100));
                _this15.$emit('updateShow', false);
                _this15.$emit('updateData', data);
              } else {
                if (rtn.text) {
                  text = rtn.text;
                  if (rtn.err) {
                    text = text + rtn.err;
                  }
                } else {
                  text = _this15.$t("Error saving time entry");
                }
                _this15.$store.state.response_alert = {
                  name: "Kullanıcı",
                  title: _this15.$t("Christ no!"),
                  text: text,
                  status: true,
                  modal: true,
                  class: "warning"
                };
              }
              _this15.start_notify();
              _this15.saving = false;
            case 13:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    list_time_entries: function list_time_entries(record_id, record_owner, status, type) {
      var _this16 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var search, time_entries;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              // console.log("list_time_entries")
              _this16.all_time_entries = [];
              search = {};
              if (type == "THREAD") {
                search.thread = record_id;
              }
              if (type == "EVENT") {
                search.event = record_id;
              }
              if (type == "TASK") {
                search.task = record_id;
              }
              if (record_owner) {
                search.record_owner = record_owner;
              }
              if (status) {
                search.status = status;
              } else {
                search.status = 1;
              }
              _context16.next = 9;
              return requests.get_time_entry(search);
            case 9:
              time_entries = _context16.sent;
              _this16.all_time_entries = time_entries.records;
            case 11:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    total_time: function total_time() {
      var all = this.all_time_entries;
      var total = 0;
      if (all && _typeof(all) == "object") {
        all.forEach(function (e) {
          var h = e.hours * 60;
          var m = e.minutes;
          total += h + m;
        });
      }
      var to = Math.floor(total / 60);
      var mi = Math.floor(total - to * 60);
      var ho = to ? to + 's ' : '';
      var min = mi ? mi + 'dk. ' : '';
      return ho + " " + min;
    },
    get_attachments: function get_attachments(record_id, app, model, record_owner, status) {
      var _this17 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var search, attachments, total;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _this17.attachments = [];
              search = {};
              if (record_id) {
                search.record_id = record_id;
              }
              if (app) {
                search.app = app;
              }
              if (model) {
                search.model = model;
              }
              if (record_owner) {
                search.record_owner = record_owner;
              }
              if (status) {
                search.status = status;
              } else {
                search.status = 1;
              }
              _context17.next = 9;
              return requests.get_attachments(search);
            case 9:
              attachments = _context17.sent;
              total = attachments && attachments.records ? attachments.records.length : 0;
              _this17.$emit("setTotal", total);
              _this17.attachments = attachments ? attachments.records : [];
            case 13:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }))();
    },
    get_attachment: function get_attachment(record_id, attachment_id, status) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var search, att;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              search = {};
              if (record_id) {
                search.record_id = record_id;
              }
              if (attachment_id) {
                search.attachment_id = attachment_id;
              }
              if (status) {
                search.status = status;
              } else {
                search.status = 1;
              }
              _context18.next = 6;
              return requests.get_attachment(search);
            case 6:
              att = _context18.sent;
              return _context18.abrupt("return", att);
            case 8:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }))();
    },
    delete_attachment: function delete_attachment(record_id, attachment_id, app, model, status) {
      var _this18 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var rtn, text;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _this18.saving = true;
              _context19.next = 3;
              return requests.delete_attachment({
                attachment_id: attachment_id,
                record_id: record_id
              });
            case 3:
              rtn = _context19.sent;
              _this18.saving = false;
              _this18.get_attachments(record_id, app, model);
              text = "";
              if (rtn.status == "Success") {
                if (rtn.text) {
                  text = rtn.text;
                } else {
                  text = _this18.$t("The file was successfully deleted.");
                }
                _this18.$store.state.response_alert = {
                  name: "Kullanıcı",
                  title: _this18.$t("Congratulations"),
                  text: text,
                  status: true,
                  modal: true,
                  class: "success"
                };
              } else {
                if (rtn.text) {
                  text = rtn.text;
                  if (rtn.err) {
                    text = text + rtn.err;
                  }
                } else {
                  text = _this18.$t("An error occurred while deleting the file.");
                }
                _this18.$store.state.response_alert = {
                  name: "Kullanıcı",
                  title: _this18.$t("Christ no!"),
                  text: text,
                  status: true,
                  modal: true,
                  class: "warning"
                };
              }
              _this18.start_notify();
              // this.attachments = attachments.records ? attachments.records.records : [];   
            case 9:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }))();
    },
    upload_task_attachment: function upload_task_attachment(whichOne, files, recordId) {
      var _arguments5 = arguments,
        _this19 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var app, model, all, count, total;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              app = _arguments5.length > 3 && _arguments5[3] !== undefined ? _arguments5[3] : 'act';
              model = _arguments5.length > 4 && _arguments5[4] !== undefined ? _arguments5[4] : 'task';
              // console.log("uploadFiles",this.$refs.inputUpload.uploadFiles)
              console.log("files", files);
              _this19.loadingFiles = true;
              if (_this19.files_available) {
                _this19.files_available = false;
              }
              if (!files) {
                files = _this19.$refs.inputUpload.uploadFiles;
              } else {}
              all = Object.keys(files);
              if (whichOne == "last") {
                all = [Object.keys(files).pop()];
              }
              // let f = this.mfile = this.$refs.inputUpload.files[0]
              if (!recordId) {
                recordId = _this19.record_id;
              }
              count = 1;
              total = all.length;
              console.log("all", all);
              console.log("files2", files);
              new Promise( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(resolve, reject) {
                  return _regeneratorRuntime().wrap(function _callee21$(_context21) {
                    while (1) switch (_context21.prev = _context21.next) {
                      case 0:
                        _context21.next = 2;
                        return all.forEach( /*#__PURE__*/function () {
                          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(key) {
                            var f, fd, filename, rtn, text;
                            return _regeneratorRuntime().wrap(function _callee20$(_context20) {
                              while (1) switch (_context20.prev = _context20.next) {
                                case 0:
                                  f = files[key];
                                  fd = new FormData();
                                  if (f.raw) {
                                    fd.append('file', f.raw, f.name);
                                  } else {
                                    filename = f.name ? f.name : "file.png";
                                    fd.append('file', f, filename);
                                  }
                                  fd.append('record_id', recordId);
                                  fd.append('attachment_id', '');
                                  _this19.saving = true;
                                  _context20.next = 8;
                                  return requests.upload_attachments({
                                    files: fd,
                                    record_id: recordId,
                                    app: app,
                                    model: model
                                  });
                                case 8:
                                  rtn = _context20.sent;
                                  _this19.saving = false;
                                  text = "";
                                  if (!(rtn.status == "Success")) {
                                    _context20.next = 24;
                                    break;
                                  }
                                  if (rtn && rtn.text) {
                                    text = rtn.text;
                                  } else {
                                    text = _this19.$t("The file has been successfully saved.");
                                  }
                                  if (!(count == total)) {
                                    _context20.next = 21;
                                    break;
                                  }
                                  _this19.loadingFiles = false;
                                  _this19.$store.state.response_alert = {
                                    name: "Kullanıcı",
                                    title: _this19.$t("Congratulations"),
                                    text: text,
                                    status: true,
                                    modal: true,
                                    class: "success"
                                  };
                                  resolve(true);
                                  _context20.next = 19;
                                  return _this19.get_attachments(recordId, app, model);
                                case 19:
                                  _this19.modal_key = "k" + Math.random(1, 9999);
                                  if (typeof _this19.fieldVisible != "undefined") {
                                    _this19.fieldVisible.documents = false;
                                  }
                                case 21:
                                  delete files[0];
                                  _context20.next = 27;
                                  break;
                                case 24:
                                  if (count == total) {
                                    reject(true);
                                    _this19.loadingFiles = false;
                                  }
                                  if (rtn.text) {
                                    text = rtn.text;
                                    if (rtn.err) {
                                      text = text + rtn.err;
                                    }
                                  } else {
                                    text = _this19.$t("An error occurred while saving the file.");
                                  }
                                  _this19.$store.state.response_alert = {
                                    name: "Kullanıcı",
                                    title: _this19.$t("Christ no!"),
                                    text: text,
                                    status: true,
                                    modal: true,
                                    class: "warning"
                                  };
                                case 27:
                                  count++;
                                case 28:
                                case "end":
                                  return _context20.stop();
                              }
                            }, _callee20);
                          }));
                          return function (_x3) {
                            return _ref2.apply(this, arguments);
                          };
                        }());
                      case 2:
                      case "end":
                        return _context21.stop();
                    }
                  }, _callee21);
                }));
                return function (_x, _x2) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 14:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }))();
    }
  }
};